import axios from 'axios';
import router from '../router/index.js'
import store from '../store/index.js'
import { Message } from 'element-ui'

// 创建 axios 实例
let http = axios.create({
	timeout: 60000
});
// 设置 post、put 默认 Content-Type
http.defaults.baseURL = 'https://ht.daiyuart.com/api.php/set';
http.defaults.headers.post['Content-Type'] = 'application/json';
http.defaults.headers.put['Content-Type'] = 'application/json';
// http.defaults.headers.post['TOKEN'] = 'newClient1(3^2`';

// 添加请求拦截器
http.interceptors.request.use(config => {
	const token = localStorage.getItem('token');
	if (token) {
		config.headers['x-token'] = token
	}
	if (config.method === 'post' || config.method === 'put') {
		// post、put 提交时，将对象转换为string, 为处理Java后台解析问题
		config.data = JSON.stringify(config.data);
	} else if (config.method === 'get' && !!window.ActiveXObject) {
		// 给GET 请求后追加时间戳， 解决IE GET 请求缓存问题
		let symbol = config.url.indexOf('?') >= 0 ? '&' : '?';
		config.url += symbol + '_=' + Date.now();
	}
	// 请求发送前进行处理
	return config;
}, error => {
	// 请求错误处理
	return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(response => {
	let {
		data
	} = response;
	if (data.code === 405) {
		if (router.currentRoute.path != '/login') {
			Message.error('登录失效，请重新登陆');
			localStorage.clear();
			store.dispatch('updateShopStatus', 1)
			router.replace({
				path: '/login'
			})
		}
		// Message.error('登录失效，请重新登陆');
		// router.replace({'path':'/login',query:{'logInType':1}})
		// setTimeout(function () {
		// 	window.location.href = '/';
		// }, 2000);
	}
	if (data.code === 403) {
		// Message.error(data.msg);
		// setTimeout(function () {
		// 	window.location.href = '/';
		// }, 2000);
	}
	if (response.config.url == '/login') {
		if (data.code === 200) {
			// Message.success(data.msg)
		} else {
			// Message.error(data.msg);
		}
	}
	// if (data.code === 200) {
	//   Message.success(data.msg)
	// }else{
	//   Message.error(data.msg);
	// }
	return data;
}, error => {
	let info = {};
	let {
		status,
		statusText,
		data
	} = error.response;
	if (!error.response) {
		info = {
			result: 5000,
			msg: 'Network Error'
		};
	} else {
		// 此处整理错误信息格式
		info = {
			result: status,
			data: data,
			msg: statusText
		};
	}
	return Promise.reject(info);
});

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function() {
	return http;
}